import React from "react";

type ItalicFontProps = {
  color?: string;
};

const ItalicFont: React.FC<ItalicFontProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 20V17H8.375L12.375 7H9V4H19V7H15.625L11.625 17H15V20H5Z"
        fill={color}
      />
    </svg>
  );
};

export default ItalicFont;
